
const hostname = window && window.location && window.location.origin;
const basePath = "/workflow/firm";
const domain = `${hostname}${basePath}/v1/CCHiFirm`

export default {
  getFirmConfiguration: `${domain}/GetFirmConfigurationByFirmId`,
  addFirmConfiguration: `${domain}/AddFirmConfiguration`,
};